
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Switch,
    FormControl,
    FormLabel,
    FormControlLabel,
    Dialog,
    DialogTitle,
    Divider,
    Slide,
    InputLabel,
    Select,
    Grid,
    Button
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutTabModel,
        LayoutSectionModel,
        LayoutFieldModel,
        LookupFieldModel,
        RecordModel,
        RecordFactory} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {CalendarDialogComponent} from "../../components/calendarDialog/CalendarDialog";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from 'dayjs';
import { formatDate } from "../../utils/dateFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../app/globalLayoutSlice";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getAppName} from "../../utils/helperRouter";
import {DeleteDialogComponent} from "./DeleteDialog";
import {LayoutSectionComponent} from "../layoutSection/LayoutSection";

/*

COMPONENT FOR DISPLAYING RECORD FROM A SELECTED TAB

*/

export const RecordTabPanelComponent: React.FC<{
  layoutTab: LayoutTabModel,
  record: RecordModel,
  saveChanges: (updatedRecord: RecordModel) => void;
  deleteRecord: (thisRecord: RecordModel) => void;
}> = ({
  layoutTab,
  record,
  saveChanges,
  deleteRecord
}) => {

  const styles = ContainerClasses();

  const dispatch = useDispatch<any>();

  let {appName, objectName, recordUuid} = useParams();

  const [mutableRecord, setMutableRecord] = useState<RecordModel>(new RecordFactory().deepCopy(record));
  const [recordChanged, setRecordChanged] = useState<Boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);

  const navigate = useNavigate();

  const discardChanges = () => {
    setMutableRecord(new RecordFactory().deepCopy(record));
    setRecordChanged(false);
  }

  const sortFunction = (layoutSectionA: LayoutSectionModel,
                        layoutSectionB: LayoutSectionModel) => {
    //sort layout sections by rank
    let sortIndex = 1
    layoutSectionA.Rank_sys > layoutSectionB.Rank_sys ? sortIndex = 1 : sortIndex=-1;
    return sortIndex
  }


  return (

    <>
      <DeleteDialogComponent
        openDialog={openDeleteDialog}
        onCloseDialog={() => {
            setOpenDeleteDialog(false)
          }}
        onDelete={() => {
           setOpenDeleteDialog(false);
           deleteRecord(mutableRecord);
         }}
      />

      <Box
        sx={{display: 'flex',
             flexDirection: 'column',
             gap: 2}}
      >
        {layoutTab.layout_sections.filter((layout_section) => { //for now, display everything
                                                              return layout_section.DetailHeading_sys === true ||
                                                                     layout_section.EditHeading_sys === true} )
                                  .sort((a,b) => sortFunction(a,b))
                                  .map((layout_section) => {
              return (
                   <LayoutSectionComponent
                      key={layout_section.Uuid_sys}
                      layoutSection={layout_section}
                      record={mutableRecord}
                      onChange={() => setRecordChanged(true)}
                   />
                 )
               })
          }

          <Box
            sx={{display: 'flex',
                 flexDirection: 'row',
                 justifyContent: 'center',
                 gap: 2}}
          >

            <Button
              color="primary"
              variant="contained"
              disabled={recordChanged === true ? false : true}
              onClick={() => {
                  setRecordChanged(false);
                  saveChanges(mutableRecord)
                }
              }
            >
              Save
            </Button>

           <Button
             color="primary"
             variant="contained"
             disabled={recordChanged === true ? false : true}
             onClick={() => discardChanges()}
           >
             Discard changes
           </Button>

           <Button
             color="error"
             variant="contained"
             onClick={() => setOpenDeleteDialog(!openDeleteDialog)}
           >
             Delete
           </Button>

         </Box>

      </Box>

    </>
  );

};
